import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { Vehicle } from './vehicle';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({ providedIn: 'root' })
export class VehicleService {

    private api_url = `${environment.ApiUrl}/vehicle`;

    constructor(private http: HttpClient) { }

    findAll() {
        return this.http.get<Vehicle[]>(this.api_url);
    }

    save(vehicle: Vehicle) {
        return this.http.post<Vehicle>(this.api_url, vehicle, httpOptions);
    }

    update(vehicle: Vehicle) {
        return this.http.put<Vehicle>(this.api_url, vehicle, httpOptions);
    }

    delete(vehicle: Vehicle) {
        const url = `${this.api_url}/${vehicle.id}`;
        return this.http.delete(url, httpOptions);
    }
}